import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  DEBTOR_DOCUMENT_LIST_ERROR,
  DEBTOR_DOCUMENT_LIST_LOADING,
  DEBTOR_DOCUMENT_LIST_SUCCESS,
  DEBTOR_DOCUMENT_LIST_ORDER
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  filter: {
    originalName: ''
  },
  order: {
    field: 'originalName', 
    direction: 'asc'
  }
};

function error(error) {
  return {type: DEBTOR_DOCUMENT_LIST_ERROR, error};
}

function loading(loading) {
  return {type: DEBTOR_DOCUMENT_LIST_LOADING, loading};
}

function success(items) {
  return {type: DEBTOR_DOCUMENT_LIST_SUCCESS, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  order: state => state.order,
  filter: state => state.filter
};

const actions = {
    getItems({ commit, state }, debtorId) {
      commit(loading(true));
      commit(error(null));

      const page = '/debtors/' + debtorId + '/files'

      return http.fetch(page + '?' + http.buildQueryParams(state.currentPage,state.order, state.filter))
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    },
    order: function(context, column) {
      context.commit(DEBTOR_LIST_ORDER, column);
      context.dispatch('getItems');
    }
};

const mutations = {
    [DEBTOR_DOCUMENT_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [DEBTOR_DOCUMENT_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [DEBTOR_DOCUMENT_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [DEBTOR_DOCUMENT_LIST_ORDER] (state, column) {
      if (state.order.field == column && state.order.direction !== 'desc') {
        state.order.direction = 'desc';
      }
      else if (state.order.field == column && state.order.direction == 'desc') {
        state.order.field = '';
      }
      else {
        state.order.direction = 'asc';
        state.order.field = column;
      }
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/debtor/document-list.js